import React, { memo } from 'react';
import { FadeIn } from '../ui/FadeIn';
import { AlertTriangleIcon, XCircleIcon } from 'lucide-react';
export function ProblemSection() {
  const failedAttempts = ['Seguiste rutinas genéricas sin análisis profundo.', 'Usaste PDFs sueltos sin estructura ni fundamento real.', 'Improvisaste sin un criterio técnico claro.', 'Intentaste memorizar terminología compleja sin una guía visual.', 'Dependiste de la intuición en vez de un sistema analizado y listo para consultar.'];
  return <section className="py-10 bg-card/50 border-y border-card-border relative overflow-hidden" data-id="element-205">
      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-206">
        {/* Hook */}
        <FadeIn data-id="element-207">
          <div className="bg-background border border-card-border rounded-2xl p-6 md:p-10 mb-12 shadow-2xl relative" data-id="element-208">
            <div className="absolute -top-6 left-1/2 -translate-x-1/2 bg-primary text-white px-6 py-2 rounded-full font-bold text-sm uppercase tracking-wider shadow-lg" data-id="element-209">
              La Realidad
            </div>
            <p className="text-xl md:text-2xl leading-relaxed text-gray-300 italic text-center" data-id="element-210">
              "Imaginá estar frente a tus alumnos o clientes. Te preguntan:{' '}
              <span className="text-primary font-semibold" data-id="element-211">
                ¿Por qué este ejercicio?
              </span>{' '}
              Sentís esa duda interna. No porque no sepas entrenar, sino porque
              no siempre tenés la justificación técnica lista. Esa inseguridad
              frena tu avance."
            </p>
          </div>
        </FadeIn>

        {/* The Problem */}
        <FadeIn delay={0.2} data-id="element-212">
          <div className="mb-14 text-center" data-id="element-213">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-red-500/10 text-red-500 mb-6" data-id="element-214">
              <AlertTriangleIcon className="w-8 h-8" data-id="element-215" />
            </div>
            <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-216">
              El Problema Real
            </h2>
            <p className="text-lg text-gray-400 max-w-2xl mx-auto leading-relaxed" data-id="element-217">
              La mayoría de los profes y entrenadores repiten ejercicios porque
              "funcionan", pero no cuentan con una base técnica detallada para
              justificarlos. A veces improvisan. O usan la intuición. Pero
              cuando llega el momento de explicar el porqué de cada elección,
              ahí aparece el vacío técnico.{' '}
              <strong className="text-white font-semibold" data-id="element-218">
                Tus alumnos notan esa falta de seguridad. Y eso frena tu
                crecimiento profesional.
              </strong>
            </p>
          </div>
        </FadeIn>

        {/* Failed Attempts */}
        <FadeIn delay={0.3} data-id="element-219">
          <div className="bg-card border border-red-500/20 rounded-2xl p-6 md:p-10" data-id="element-220">
            <h3 className="text-2xl font-bold mb-6 text-center text-red-400" data-id="element-221">
              Por Qué Lo Que Intentaste No Funcionó
            </h3>
            <ul className="space-y-4" data-id="element-222">
              {failedAttempts.map((attempt, index) => <FadeIn key={index} delay={0.4 + index * 0.1} direction="left" data-id="element-223">
                  <li className="flex items-start gap-4 p-4 rounded-xl bg-background/50 border border-card-border hover:border-red-500/30 transition-colors" data-id="element-224">
                    <XCircleIcon className="w-6 h-6 text-red-500 shrink-0 mt-0.5" data-id="element-225" />
                    <span className="text-gray-300 text-lg" data-id="element-226">{attempt}</span>
                  </li>
                </FadeIn>)}
            </ul>
          </div>
        </FadeIn>
      </div>
    </section>;
}